<template>
    <div>
        <div class="employees-header">
            <span class="employees-add">Employees</span>
            <v-tooltip class="employees-add-button" bottom color="grey">
                <v-btn class="item-add-button-icon" flat color="black" slot="activator" @click="addEmployee">
                    <v-icon class="employees-add-icon" color="indigo">mdi-plus</v-icon>
                </v-btn>
                <span>Add new employee</span>
            </v-tooltip>
        </div>
        <div class="employees-info">
            <div v-for="(employee, key) in this.$parent.paginateEmployees" :key="key" class="employee-info-tile" @click="$parent.employeeViewMobile(employee.userId)">
                <div class="employee-avatar">
                    <v-avatar size="35px">
                        <img :src="srcPhoto(employee.photoUrl)" alt="avatar" class="employee-image">
                    </v-avatar>
                </div>
                <div class="employee-personal">
                    <div class="employee-name mr-2">
                        <span class="employee-word-nowrap">{{employee.lastName}} {{employee.firstName}}</span>
                    </div>
                    <div class="employee-roles mr-2">
                        <span class="employee-role" v-for="(role, key) in employee.roles" :key="key">{{role.name}}</span>
                    </div>
                </div>
                <div class="employee-more-info">
                    <div class="employee-more-info-button">
                        <v-btn icon slot="activator">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import socials from '@/constants/socials';
    import employeeMixin from '@/constants/employee-mixin';
    export default {
        name: 'employeesMobile',
        data() {
            return {
                socials: socials
            };
        },
        computed: {
            ...mapGetters({
                employees: 'getEmployees',
                searchEmployees: 'getSearchEmployees'
            })
        },
        mixins: [employeeMixin]
    };
</script>

<style scoped>
    .employees-info {
        display: flex;
        flex-direction: column;
        min-width: 100px;
        margin: 10px;
        margin-top: 11px;
        -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)!important;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)!important;
    }
    .employee-info-tile {
        height: 61px;
        width: 100%;
        display: flex;
        flex-direction: row;
        cursor: pointer;
    }
    .employee-avatar {
        display: flex;
        flex-direction: row;
        align-content: center;
        align-items: center;
        min-height: 70px;
        min-width: 70px;
        padding-left: 14px;
        margin-top: -5px;
    }
    .employee-personal {
        width: 90%;
        padding-top: 16px;
        margin-left: -2px;
        border-bottom: 1px solid rgba(0, 0, 0, .12);
        overflow: hidden;
    }
    .employee-name {
        font-size: 13px;
        margin-top: -3px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .employee-roles {
        margin-left: -1px;
        margin-top: -4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .employee-role {
        font-size: 12px;
        padding-left: 2px;
        padding-right: 2px;
        color: rgba(0, 0, 0, .60) !important;
    }
    .employee-more-info {
        width: 10%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        border-bottom: 1px solid rgba(0, 0, 0, .12);
    }
    .employee-more-info-button {
        margin-top: 5px;
        margin-right: -6px;
    }
    .employee-image {
        object-fit: cover; 
    }

</style>


// WEBPACK FOOTER //
// src/components/adaptive/employees-mobile.vue